import IAddress from "./IAddress";
import IBankAccount from "./IBankAccount";

export default interface NaturalPerson {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  state: NaturalPersonState;

  // Name
  firstName?: string;
  lastName?: string;
  gender?: EGender;

  // Address
  phoneNumberPrefix?: string;
  phoneNumber?: string;
  addrCountryCode?: string;
  addrCountry?: string;
  addrState?: string;
  addrCity?: string;
  addrPostalCode?: string;
  addrStreetName?: string;
  addrStreetNumber?: string;
  addrAddition?: string;
  address?: IAddress;

  // Birthdata
  nationality?: string;
  birthday?: string;
  birthPlaceText?: string;
  birthPlaceCountry?: string;

  // BankAccount
  bankAccount?: IBankAccount;

  // Verification
  verificationDocumentType?: EVerificationDocumentType;
  verificationDocumentNumber?: string;
  verificationDocumentIssuingAgency?: string;

  // Feedback
  recommendation?: string;
  recommendationFreeText?: string;
  subscribedToNewsletter?: boolean;

  // Tax
  taxId?: string;
}

export enum EGender {
  male = "male",
  female = "female",
  diverse = "diverse"
}

export enum EVerificationDocumentType {
  identityCard = "identityCard",
  passport = "passport"
}

export enum ERecommendation {
  financeConsultancy = "financeConsultancy",
  offlineMedia = "offlineMedia",
  onineMedia = "onlineMedia",
  socialMedia = "socialMedia",
  searchEngine = "searchEngine",
  triodos = "triodos",
  events = "events",
  recommendation = "recommendation",
  wdsMail = "wdsMail",
  articlePrint = "articlePrint",
  articleOnline = "articleOnline",
  forgot = "forgot",
  other = "other"
}

export enum NaturalPersonState {
  none = "none",
  name = "name",
  address = "address",
  birthData = "birthData",
  verification = "verification",
  feedback = "feedback",
  finished = "finished"
}
